<template>
  <form @submit="onSubmit">
    <p class="modal_text error_message">
      <span v-show="afterSubmitErrorMsg" class="error_message_text">{{ afterSubmitErrorMsg }}</span>
    </p>
    <div class="box_content form-group" :class="emailError?'error':''" data-name="loginEmail">
      <label for="loginEmail"></label>
      <input type="email" class="form-control" id="loginEmail" name="email" v-model="email" aria-describedby="emailHelp"
             placeholder="請輸入您的Email" @focus="inputFocusFunc" @blur="inputBlurFunc">
      <small id="emailHelp" class="form-text">{{ emailError }}</small>
    </div>
    <div class="box_content form-group" :class="passwordError?'error':''" data-name="loginPassword">
      <label for="loginPassword"></label>
      <input type="password" class="form-control" id="loginPassword" name="password" v-model="password"
             aria-describedby="passwordHelp" placeholder="請輸入您的密碼" @focus="inputFocusFunc" @blur="inputBlurFunc">
      <small id="passwordHelp" class="form-text">{{ passwordError }}</small>
    </div>
    <div class="modal_bottom">
      <div class="modal_btn_wrapper row">
        <div class="col-12">
          <button class="btn primary lg" :disabled="!meta.valid || isSubmitting">
            <span class="btn_text">登入</span>
          </button>
        </div>
      </div>
      <div class="modal_desc_wrapper">
        <div class="modal_desc_content">
          <span class="modal_desc_text desc">還不是會員嗎？</span>
          <a :href="'/premium?utm_source=sehseh_login&utm_medium='+this.nid" class="modal_desc_link desc">立即加入訂閱</a>
        </div>
        <div class="modal_desc_content">
          <a href="javascript:void(0);" class="modal_desc_link desc" @click="$emit('goForget')">忘記密碼?</a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {ref} from "vue";
import {useForm, useField} from 'vee-validate';
import {loginPost} from '@vuePath/api/login';
import {inputFocus, inputBlur} from "@vuePath/tools/tool";
import * as yup from 'yup';

export default {
  name: "LoginForm",
  props: {
    redirectUrl: {
      type: String,
      default: ""
    }
  },
  emit: ['goForget'],
  setup(props) {
    // Check if has nid for utm
    const nid = document.getElementById('hidden_nid') ? document.getElementById('hidden_nid').value : 'none';
    // Define a validation schema
    const schema = yup.object({
      email: yup.string().required("請輸入Email地址").email("格式錯誤，請再確認"),
      password: yup.string().required("請輸入密碼").matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/, { message: "6-20位英數(須包含1個數字、1個英文字母)", excludeEmptyString: true }),
    });

    // Create a form context with the validation schema
    const {meta, handleSubmit, isSubmitting} = useForm({
      validationSchema: schema,
    });

    // No need to define rules for fields
    const {value: email, errorMessage: emailError} = useField('email');
    const {value: password, errorMessage: passwordError} = useField('password');

    const loginSuccess = async () => {
      console.log("redirectUrl", props.redirectUrl);

      await yup.string().url().isValid(props.redirectUrl)
          .then(function (valid) {
            console.log("redirectUrl after validator!", valid, props.redirectUrl);
            if (valid) {
              window.location.href = props.redirectUrl;
            } else {
              window.location.reload();
            }
          });
    }

    const afterSubmitErrorMsg = ref("");

    const onSubmit = handleSubmit(async values => {
      // reset error msg
      afterSubmitErrorMsg.value = "";

      // Send data to the API
      await loginPost(values.email, values.password)
          .then(res => {
            console.log(res);

            if (res.data.code === "000") {
              // success login
              let { id:mid, token, nickname, expire_ts_sehseh, avatar } = res.data.data;
              let memberData = { mid, token, nickname, expire_ts_sehseh , login_time: Date.now(), avatar };
              console.log(memberData);
              Object.keys(memberData).forEach(key => {
                sessionStorage.setItem(key, memberData[key]);
              });
              window.localStorage.setItem('login', JSON.stringify(memberData));
              loginSuccess();
            } else if (res.data.code === "422") {
              afterSubmitErrorMsg.value = "帳號或密碼錯誤";
            } else if (res.data.code === "446") {
              afterSubmitErrorMsg.value = "密碼錯誤";
            } else if (res.data.code === "447") {
              afterSubmitErrorMsg.value = "帳號不存在";
            } else {
              afterSubmitErrorMsg.value = '系統錯誤';
            }
          })
          .catch(function (err) {
            console.log(err);
          });
    });

    return {
      nid,
      meta,
      email,
      emailError,
      password,
      passwordError,
      onSubmit,
      isSubmitting,
      afterSubmitErrorMsg
    };
  },
  methods: {
    inputFocusFunc(e) {
        inputFocus(e);
    },
    inputBlurFunc(e) {
        inputBlur(e);
    }
  }
}
</script>